/**
 * Renders the mobile-only "View Floor Plan" button shown on floorPlanDetail's Configuration tab
 * — clicking it expands the layout image full-screen (see plugins/floorPlanDetail.plugin.js,
 * which listens for its `data-image-expand-button` attribute and shows components/floorPlanViewer.dom.js).
 * Pure function — no DOM mounting, no event logic — matching this folder's existing .dom.js convention (see
 * floorPlanImage.dom.js). Whether/when to render it is the caller's decision (plugin state), not
 * this component's.
 *
 * Styled entirely with the existing button component classes (_components.button.scss) — no
 * dedicated component class of its own.
 *
 * @module nativeInteractiveSiteMap/components/viewFloorPlanButton.dom
 */

/**
 * @returns {string} HTML string.
 */
export default function renderViewFloorPlanButton() {
  return `
    <button type="button"
            class="nhs-c-button--text-only nhs-c-button--primary-ui nhs-o-typography--sans-body-1-small-regular nhs-u-padding--159-200 nhs-u-radius--1000 nhs-u-margin--top-0"
            data-image-expand-button
            data-qa="native_ism_floor_plan_image_expand_button">
      View floor plan
    </button>
  `;
}
